import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add_oval",
  "use": "icon-add_oval-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 26 26\" id=\"icon-add_oval\">\n    <circle cx=\"13\" cy=\"13\" r=\"13\" fill=\"#FFBC20\" />\n    <path stroke=\"#fff\" stroke-width=\"1.286\" d=\"M7.43 13.371h11.885M13.371 19.314V7.43\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol